<template>
  <div id="app" class="wrapper" :class="{ 'chat-docked': isChatOpen }">
    <div class="cookie-consent shadow-lg" v-if="!areCookiesAccepted">
      <div class="container mt-4">
        <h4>Utilizamos cookies</h4>
        <p>
          Este sitio web utiliza cookies propias y de terceros, el uso del mismo implica la aceptación de la <router-link to="politica-de-cookies">Política de cookies</router-link>
        </p>
        <button class="btn btn orange-button mb-4" @click="acceptCookies">Aceptar</button>
      </div>
    </div>
    <div class="preloader"></div>
      <!-- Main Header Nav -->
      <header v-if="['Home', 'Sell','Buy'].includes($route.name)" class="header-nav menu_style_home_one home4_style navbar-scrolltofixed stricky main-menu">
        <div class="container"> 
          <!-- Ace Responsive Menu -->
          <nav> 
            <!-- Menu Toggle btn-->
            <div class="menu-toggle">
              <img class="nav_logo_img img-fluid" src="./assets/static/avanza.png" alt="avanza.png">
              <button type="button" id="menu-btn">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <router-link to="/" class="navbar_brand float-left dn-md">
              <img class="logo1 img-fluid" src="./assets/static/avanza-white.png" alt="avanza-white.png">
              <img class="logo2 img-fluid" src="./assets/static/avanza.png" alt="avanza.png">
            </router-link> 
            <!-- Responsive Menu Structure-->
            <ul id="respMenu" class="ace-responsive-menu text-right" data-menu-style="horizontal">
              <li class="mr-2"><router-link to="/">Inicio</router-link></li>
              <li class="mr-2"><a href="/listado-inmuebles?operacion=venta">Venta</a></li>
              <li class="mr-2"><a href="/listado-inmuebles?operacion=alquiler">Alquiler</a></li>
              <li class="mr-2"><a href="https://blog.avanzainmuebles.com">Noticias</a></li>
              <li class="mr-2"><router-link to="/vender-alquilar">Anuncia tu inmueble</router-link></li>
              <li><router-link to="/encontrar-un-hogar">Encontrar tu hogar</router-link></li>
            </ul>
          </nav>
        </div>
      </header>
      <header v-else class="header-nav menu_style_home_one style2 menu_boxshadow navbar-scrolltofixed stricky main-menu ">
        <div class="container p0">
          <!-- Ace Responsive Menu -->
          <nav>
            <!-- Menu Toggle btn-->
            <div class="menu-toggle"><img class="nav_logo_img img-fluid" src="./assets/static/avanza-white.png" alt="avanza-white.png">
              <button type="button" id="menu-btn"><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></button>
            </div>
            <router-link to="/" class="navbar_brand float-left dn-md"><img class="logo1" src="./assets/static/avanza.png" alt="avanza.png" height="40px"><img class="logo2" src="./assets/static/avanza.png" alt="avanza.png"></router-link>
            <!-- Responsive Menu Structure-->
            <ul id="respMenu" class="ace-responsive-menu text-right" data-menu-style="horizontal">
              <li class="mr-2"><router-link to="/">Inicio</router-link></li>
              <li class="mr-2"><a href="/listado-inmuebles?operacion=venta"><span class="title">Venta</span></a></li>
              <li class="mr-2"><a href="/listado-inmuebles?operacion=alquiler"><span class="title">Alquiler</span></a></li>
              <li class="mr-2"><a href="https://blog.avanzainmuebles.com">Noticias</a></li>
              <li class="mr-2"><router-link to="/vender-alquilar">Anuncia tu inmueble</router-link></li>
              <li><router-link to="/encontrar-un-hogar">Encontrar tu hogar</router-link></li>
            </ul>
          </nav>
        </div>
      </header>

      <!-- Main Header Nav For Mobile -->
      <div id="page" class="stylehome1" v-if="!(['Home', 'Sell','Buy'].includes($route.name))">
        <div class="mobile-menu">
          <div class="header stylehome1">
            <div class="main_logo_home2 text-center"><img style="margin-top:25px !important" class="nav_logo_img img-fluid mt10" src="./assets/static/avanza-white.png" alt="header-logo.svg"></div>
            <ul class="menu_bar_home2">
              <li class="list-inline-item"><a class="custom_search_with_menu_trigger msearch_icon" href="#"></a></li>
              <li class="list-inline-item"><!--<a class="muser_icon" href="#" data-toggle="modal" data-target="#logInModal"><span class="flaticon-user"></span></a>--></li>
              <li class="list-inline-item"><a class="menubar" href="#menu"><span></span></a></li>
            </ul>
          </div>
        </div>
        <!-- /.mobile-menu -->
        
      </div>
      <!-- Menú móvil: drawer propio controlado por Vue (sustituye a mmenu, que
           manipulaba el DOM y rompía con la SPA). Cualquier clic en .menubar lo abre. -->
      <transition name="av-drawer">
        <nav class="av-drawer" v-if="mobileMenuOpen">
          <div class="av-drawer__head">
            <img class="av-drawer__logo" src="./assets/static/avanza-white.png" alt="Avanza">
            <button type="button" class="av-drawer__close" @click="mobileMenuOpen=false" aria-label="Cerrar menú">&times;</button>
          </div>
          <ul>
            <li><router-link to="/" @click.native="mobileMenuOpen=false">Inicio</router-link></li>
            <li><router-link :to="{ path:'/listado-inmuebles', query:{ operacion:'venta' } }" @click.native="mobileMenuOpen=false">Venta</router-link></li>
            <li><router-link :to="{ path:'/listado-inmuebles', query:{ operacion:'alquiler' } }" @click.native="mobileMenuOpen=false">Alquiler</router-link></li>
            <li><a href="https://blog.avanzainmuebles.com">Noticias</a></li>
            <li><router-link to="/vender-alquilar" @click.native="mobileMenuOpen=false">Anuncia tu inmueble</router-link></li>
            <li><router-link to="/encontrar-un-hogar" @click.native="mobileMenuOpen=false">Encontrar tu hogar</router-link></li>
          </ul>
        </nav>
      </transition>
      <div class="av-drawer__backdrop" v-if="mobileMenuOpen" @click="mobileMenuOpen=false"></div>
    
    <div id="page">
      <router-view/>
    </div>

    <div class="py-5" style="background-color:#222222">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-3 mb-3">
            <h5 class="text-white" style="font-weight:700;">Contacto</h5>
            <ul>
              <li><a class="text-white" href="mailto:info@avanzainmuebles.com">info@avanzainmuebles.com</a></li>
              <li><a class="text-white" href="tel:34966119554">+34 966 119 554</a></li>
              <li><a class="text-white" href="tel:34691209742">+34 691 209 742</a></li>
              <li class="text-white">Av. Constitución, 104 Entlo. - B Villena 03400 (Alicante)</li>
            </ul>
          </div>
          <div class="col-12 col-lg-3 mb-3">
            <h5 class="text-white" style="font-weight:700;">Avanza</h5>
            <ul>
              <li><router-link class="text-white" to="/vender-alquilar">Anuncia tu inmueble</router-link></li>
              <li><router-link class="text-white" to="/encontrar-un-hogar">Encuentra tu hogar ideal</router-link></li>
              <li><a class="text-white" href="https://blog.avanzainmuebles.com">Noticias</a></li>
            </ul>
          </div>
          <div class="col-12 col-lg-3 mb-3">
            <h5 class="text-white" style="font-weight:700;">Legal</h5>
            <ul>
              <li><router-link class="text-white" to="politica-de-privacidad">Política de privacidad</router-link></li>
              <li><router-link class="text-white" to="politica-de-cookies">Política de Cookies</router-link></li>
              <li><router-link class="text-white" to="aviso-legal">Avsio Legal</router-link></li>
            </ul>
          </div>
          <div class="col-12 col-lg-3 mb-3">
            <h5 class="text-white" style="font-weight:700;">Síguenos</h5>
            <div class="row">
              <a href="https://www.facebook.com/AvanzaInmuebles"><i class="fa fa-facebook text-white mr-3"></i></a>
              <a href="https://www.instagram.com/avanzainmobiliaria"><i class="fa fa-instagram text-white"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
    <a href="https://wa.me/34601539984" class="whatsapp-float" target="_blank" aria-label="Enviar mensaje por WhatsApp">
      <i class="fa fa-whatsapp whatsapp-icon"></i>
    </a>-->

    <!-- El asistente acompaña a toda la web. En la home su lanzador solo aparece
         al bajar del héroe, donde el chat ya está a la vista. -->
    <ChatDock />
  </div>
</template>

<style>
  /* --- Menú móvil propio (drawer), sin mmenu ------------------------------- */
  .av-drawer{
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: 82%;
    max-width: 320px;
    background: #1D262D;
    color: #fff;
    z-index: 10060;
    overflow-y: auto;
    box-shadow: 2px 0 24px rgba(0,0,0,0.4);
  }
  .av-drawer__head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  .av-drawer__logo{ height: 26px; }
  .av-drawer__close{
    background: none; border: none; color: #fff;
    font-size: 30px; line-height: 1; cursor: pointer; padding: 0 4px;
  }
  .av-drawer ul{ list-style: none; margin: 0; padding: 8px 0; }
  .av-drawer li{ border-bottom: 1px solid rgba(255,255,255,0.06); }
  .av-drawer a{
    display: block;
    padding: 15px 22px;
    color: #fff !important;
    font-size: 16px;
    text-decoration: none;
  }
  .av-drawer a:hover,
  .av-drawer a.router-link-exact-active{
    background: rgba(228,87,38,0.18);
    color: #fff !important;
  }
  .av-drawer__backdrop{
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 10055;
  }
  .av-drawer-enter-active, .av-drawer-leave-active{ transition: transform 0.28s ease; }
  .av-drawer-enter, .av-drawer-leave-to{ transform: translateX(-100%); }

  /* --- Layout "dos ventanas": en escritorio el chat empuja la web ------------
     En vez de superponerse, el panel ocupa una columna a la derecha y el
     contenido se estrecha, para navegar e interactuar a la vez sin solapes. */
  :root { --chat-w: 460px; }
  #app { transition: padding-right 0.28s ease; }
  @media (min-width: 992px) {
    #app.chat-docked { padding-right: var(--chat-w); }
    /* El header fijo también se estrecha (gana al width:100% del scrollToFixed) */
    #app.chat-docked header.header-nav {
      left: 0 !important;
      right: var(--chat-w) !important;
      width: auto !important;
    }
    /* La barra de cookies acompaña el estrechamiento */
    #app.chat-docked .cookie-consent {
      left: 0;
      right: var(--chat-w);
      width: auto;
    }
  }

  /* El plugin scrollToFixed fija el header con un width en px calculado al vuelo;
     con el `body { zoom: 85% }` de abajo ese ancho no cuadra con el viewport y el
     header queda estrecho. Forzamos ancho completo en el estado fijado. */
  header.stricky.stricky-fixed,
  header.navbar-scrolltofixed[style*="position: fixed"] {
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    margin-left: 0 !important;
  }

  .cookie-consent{
    background-color: white;
    width:100%;
    position:fixed;
    bottom:0;
    left:0;
    z-index:9999;
    border-radius:30px 30px 0 0;
    overflow-wrap: normal;
  }
  body{ 
    zoom:85%; 
  } 
  .form-control,.custom-select{
    height: 40px !important;
  }
  .logo1,.logo2,.nav_logo_img{
    height: 25px !important;
    margin-top: 15px;
  }

  .whatsapp-float {
      position: fixed;
      width: 70px;
      height: 70px;
      bottom: 70px;
      right: 20px;
      background-color: #E45726;
      color: white;
      border-radius: 50%;
      text-align: center;
      font-size: 30px;
      box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.3s ease;
    }

    .whatsapp-float:hover {
      background-color: #cc3e13;
    }
</style>
<script>
import ChatDock from './components/chat/ChatDock.vue'
export default {
  components: {
    ChatDock
  },
  data(){
    return {
      avanza_accepted_cookies:false,
      mobileMenuOpen:false
    }
  },
  created(){
    if($cookies.isKey("avanza_accepted_cookies")){
      this.avanza_accepted_cookies=$cookies.get("avanza_accepted_cookies")
    }
  },
  mounted(){
    // Cualquier disparador .menubar (cabeceras móviles de todas las vistas) abre el drawer.
    document.addEventListener('click', this.onMenubarClick, true)
  },
  beforeDestroy(){
    document.removeEventListener('click', this.onMenubarClick, true)
  },
  watch:{
    $route(){
      this.mobileMenuOpen = false
    }
  },
  methods:{
    onMenubarClick(e){
      const trigger = e.target.closest ? e.target.closest('a.menubar') : null
      if(trigger){
        e.preventDefault()
        this.mobileMenuOpen = true
      }
    },
    acceptCookies(){
      $cookies.set("avanza_accepted_cookies",true);
      this.avanza_accepted_cookies = true;
    }
  },
  computed:{
    areCookiesAccepted(){
      return this.avanza_accepted_cookies;
    },
    isChatOpen(){
      return this.$store.state.chat.isPanelOpen;
    }
  }
}
</script>

